import { Module } from 'vuex-smart-module';
import DataPilotActions from './actions';
import DataPilotGetters from './getters';
import DataPilotMutations from './mutations';
import { DataPilotState } from './state';
import ReasonsCommunication from './modules/client/reasons-communication';
import Products from './modules/client/products';
import EventHistory from './modules/client/event-history';

export default new Module({
  state: DataPilotState,
  mutations: DataPilotMutations,
  actions: DataPilotActions,
  getters: DataPilotGetters,
  modules: {
    reasons_communication: ReasonsCommunication,
    products: Products,
    event_history: EventHistory,
  },
});
